(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('infoScreen', {
        templateUrl: 'views/components/views/infoScreen/infoScreen.template.html?v=' + module.version,
        controllerAs: 'vm',
        //bindings: {},
        controller: ['stateService', 'infoScreenService', function (stateService, infoScreenService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;

            vm.model = {
                //setting: {}
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            //async function loadSetting() {
            //	vm.model.setting = (await infoScreenService.getSetting({ argtype: argType }))[0];
            //}

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region ON INIT FUNCTION

            //vm.$onInit = async function () {
            //	loadSetting();
            //}

            // #endregion ON INIT FUNCTION

        }]
    });
})();
